import React from "react";

import { Button } from "aible";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class FieldFeatures extends React.Component {
  render() {
    const { model, featureChart, isFeatureOpen, updateIsFeatureOpen } = this.props;

    return (
      <Dialog open={isFeatureOpen} onOpenChange={() => updateIsFeatureOpen(false)}>
        <DialogContent size="full">
          {model?.label && (
            <DialogHeader>
              <DialogTitle>{model?.label}</DialogTitle>
            </DialogHeader>
          )}
          <div className={styles.body}>{featureChart}</div>
          <DialogFooter>
            <Button type="secondary" onClick={() => updateIsFeatureOpen(false)}>
              {"Close"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
